module.exports = __webpack_public_path__ + "static/media/enjia.de57c91c.png";